import { Component, Input } from '@angular/core';

@Component({
	selector: 'app-title',
	templateUrl: './title.component.html',
	styleUrls: []
})
export class TitleComponent {
	@Input() title = 'Título por defecto';
	@Input() focusText = '';
	@Input() color = 'primary';
	@Input() headerType = '1';
	@Input() bold = true;
	@Input() center = false;
}
